import { allocateMat4 } from './_matrix-allocator.js';

function mat4Identity() {
  const m = allocateMat4();
  m[0] = 1;
  m[5] = 1;
  m[10] = 1;
  m[15] = 1;
  return m;
}

export { mat4Identity };
//# sourceMappingURL=mat4-identity.js.map
